
import {mapGetters, mapActions } from 'vuex'
export default {
  props: {
    items: {
      type: Object,
      default: () => ({}),
    },
  },
  computed:{
    ...mapGetters('noticias', [
    'newSelected',
    ]),
  },
  mounted() {
    this.loadNews(this.items.id)
  },
  
  methods: {
    ...mapActions('noticias', [
    'fetchNewsWPSelected',
    ]),
    
    acessar(){
      this.$router.push(
      `/blog/${this.items.slug}`
      )
    },
    
    async loadNews(id) {
      try {
        await this.fetchNewsWPSelected(id)
      } catch (error) {
        console.error(error)
      }
    },
  },
}
